import {
  FlatList,
  Image,
  SafeAreaView,
  StyleSheet,
  Text,
  View,
  TextInput,
  Dimensions,
  TouchableOpacity,
  TouchableWithoutFeedback,
  Modal,
  Pressable,
} from "react-native";
import React, { useState } from "react";
import AppImages from "../../Constants/AppImages";
import AppColors from "../../Constants/AppColors";
import { Driver1 } from "../../Constants/Data";
import AppFonts from "../../Constants/AppFonts";
const { height, width } = Dimensions.get("window");
const DriverUntracked = ({ navigation }) => {
  const [DotModal, setDotModal] = useState(false);
  const [select, setSelected] = useState(0);
  const [Modalvisible1, setModalvisible1] = useState(false);

  const [Modalvisible2, setModalvisible2] = useState(false);

  const [Modalvisible3, setModalvisible3] = useState(false);
  const handlePress = () => {
    setSelected(!select);
  };
  const [selectedButton, setSelectedButton] = useState(null);

  const handleBoxPressbtn = (item) => {
    setSelectedButton(item);
  };
  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: AppColors.white }}>
      <View style={{ flex: 1, marginHorizontal: 20 }}>
        <View style={{}}>
          <View style={styles.TExtinputView}>
            <TextInput
              placeholder="Search Driver......"
              placeholderTextColor="#ACACAC80"
              style={styles.TExtinput}
            />

            <TouchableOpacity
              style={{ alignSelf: "flex-end", justifyContent: "center" }}
            ></TouchableOpacity>

            <View style={styles.ExImport}>
              <Image
                source={AppImages.Import}
                style={{ width: 22, height: 22 }}
                resizeMode="contain"
              />

              <Image
                source={AppImages.Shareit}
                style={{ width: 22, height: 22, marginLeft: 10 }}
                resizeMode="contain"
              />
            </View>
          </View>
        </View>
        <FlatList
          data={Driver1}
          showsVerticalScrollIndicator={false}
          ListFooterComponent={() => <View style={{ padding: 10 }}></View>}
          renderItem={({ item }) => (
            <View
              style={{
                width: "100%",
                backgroundColor: AppColors.darkbrown,
                opacity: 0.6,
                marginBottom: 20,
                borderRadius: 10,
              }}
            >
              <View
                style={{
                  position: "absolute",
                  flex: 1,
                  alignItems: "center",
                  left: 0,
                  right: 0,
                  top: 0,
                  bottom: 0,
                  justifyContent: "center",
                }}
              >
                <Image
                  source={AppImages.Greyclose}
                  style={{
                    position: "absolute",
                    zIndex: 1,

                    width: 100,
                    height: 100,
                  }}
                />
              </View>
              <View
                style={{
                  marginTop: 10,
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <View style={{ flexDirection: "row" }}>
                  <Image
                    source={item.img1}
                    style={{ height: 48, width: 48, marginLeft: 15 }}
                  />
                  <View style={{ marginLeft: 35, flexDirection: "column" }}>
                    <Text
                      style={{
                        fontSize: 12,

                  
                        fontWeight: "400",
                        fontFamily: AppFonts.OverpassMedium,
                        color: AppColors.brown1,

                        opacity: 0.6,
                      }}
                    >
                      {item.H1}
                    </Text>
                    <Text
                      style={{
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,

                        color: AppColors.brown1,
                      }}
                    >
                      {item.H2}
                    </Text>
                  </View>
                </View>
                <TouchableOpacity
                  onPress={() => setDotModal(true)}
                  style={{
                    width: 25,
                    height: 25,
                    marginTop: 10,
                    alignItems: "flex-end",
                  }}
                >
                  <Image
                    source={item.img2}
                    resizeMode="contain"
                    style={{
                      width: 3,
                      height: 17,
                      marginRight: 20,

                      alignItems: "center",
                    }}
                  />
                </TouchableOpacity>
              </View>
              <View
                style={{
                  height: 1,
                  width: "100%",
                  backgroundColor: AppColors.linegrey,
                  marginVertical: 10,
                  opacity: 0.11,
                }}
              ></View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",

                  marginHorizontal: 20,
                }}
              >
                <Text
                  style={{
                    fontSize: 12,

fontWeight: "400",
fontFamily: AppFonts.OverpassMedium,
color: AppColors.brown1,
width: "50%",
opacity: 0.6,
                  }}
                >
                  {item.H3}
                </Text>
                <Text
                  style={{
                    fontSize: 12,

fontWeight: "400",
fontFamily: AppFonts.OverpassMedium,
color: AppColors.brown1,
width: "50%",
opacity: 0.6,
                  }}
                >
                  {item.H5}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",

                  marginHorizontal: 20,
                }}
              >
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassSemiBold,

                    fontSize: 14,
                    color: AppColors.brown1,
                    width: "50%",
                  }}
                >
                  {item.H4}
                </Text>
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassSemiBold,

                    fontSize: 14,
                    color: AppColors.brown1,
                    width: "50%",
                  }}
                >
                  {item.H6}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",

                 marginBottom:15,
                  marginHorizontal: 20,
                }}
              >
                <Text
                  style={{
                    fontSize: 12,

                    fontWeight: "400",
                    fontFamily: AppFonts.OverpassMedium,
                    color: AppColors.brown1,
                    width: "50%",
                    opacity: 0.6,
                  }}
                >
                  {item.H7}
                </Text>
                <Text
                  style={{
                    fontSize: 12,

                    opacity: 0.5,
                    fontWeight: "400",
                    fontFamily: AppFonts.OverpassMedium,
                    color: AppColors.brown1,
                    width: "50%",
                    opacity: 0.6,
                  }}
                >
                  {item.H9}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
marginTop:5,
                  marginHorizontal: 20,
                }}
              >
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassSemiBold,

fontSize: 14,
color: AppColors.brown1,
width: "50%",
                  }}
                >
                  {item.H8}
                </Text>
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassSemiBold,
                    fontWeight: "600",
                    fontSize: 14,
                    color: AppColors.brown1,
                    width: "50%",
                  }}
                >
                  {item.H10}
                </Text>
              </View>
              <View
                style={{
                  marginHorizontal: 20,
                  marginBottom: 10,
                }}
              >
                <Text
                  style={{
                    marginTop: 10,
                    fontSize: 12,

                    opacity: 0.5,
                    fontWeight: "400",
                    fontFamily: AppFonts.OverpassMedium,
                    color: AppColors.brown1,
                    width: "50%",
                    opacity: 0.6,
                  }}
                >
                  {item.H11}
                </Text>
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassSemiBold,

                    fontSize: 14,
                    color: AppColors.brown1,

                    marginTop: 5,
                  }}
                >
                  {item.H12}
                </Text>
              </View>
            </View>
          )}
        />
        <Modal
          animationType="slide"
          visible={DotModal}
          onRequestClose={() => {
            setDotModal(false);
          }}
          transparent={true}
        >
          <TouchableWithoutFeedback onPress={() => setDotModal(false)}>
            <View
              style={{ backgroundColor: AppColors.ModalColor, flex: 1 }}
            ></View>
          </TouchableWithoutFeedback>
          <View
            style={{
              width: "100%",
              backgroundColor: "white",

              borderTopRightRadius: 16,
              borderTopLeftRadius: 16,
              position: "absolute",
              bottom: 0,
              padding: 20,
            }}
          >
            <TouchableOpacity
              style={{ justifyContent: "center", alignItems: "center" }}
            >
              <Image
                source={AppImages.LineBar}
                style={{ width: "15%", height: 2 }}
              />
            </TouchableOpacity>

            <TouchableOpacity
              style={{
                marginTop: 20,
                flexDirection: "row",
              }}
              onPress={() => [
                navigation.navigate("DriversView"),
                setDotModal(false),
              ]}
            >
              <View
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: 10,
                }}
              >
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassMedium,
                    fontWeight: "400",
                    fontSize: 14,
                    color: AppColors.brown1,
                  }}
                >
                  View
                </Text>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              style={{
                marginTop: 20,
                flexDirection: "row",
              }}
              onPress={() => [
                navigation.navigate("EditDriver"),
                setDotModal(false),
              ]}
            >
              <View
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: 10,
                }}
              >
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassMedium,
                    fontWeight: "400",
                    fontSize: 14,
                    color: AppColors.brown1,
                  }}
                >
                  Edit
                </Text>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              style={{
                marginTop: 20,
                flexDirection: "row",
              }}
              onPress={() => [
                setDotModal(false),
                navigation.navigate("ChangeDriverPassword"),
              ]}
            >
              <View
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: 10,
                }}
              >
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassMedium,
                    fontWeight: "400",
                    fontSize: 14,
                    color: AppColors.brown1,
                  }}
                >
                  Change Password
                </Text>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              style={{
                marginTop: 20,
                flexDirection: "row",
              }}
              onPress={() => [setDotModal(false), setModalvisible1(true)]}
            >
              <View
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: 10,
                }}
              >
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassMedium,
                    fontWeight: "400",
                    fontSize: 14,
                    color: AppColors.brown1,
                  }}
                >
                  Block
                </Text>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              style={{
                marginTop: 20,
                flexDirection: "row",
              }}
              onPress={() => [setDotModal(false), setModalvisible2(true)]}
            >
              <View
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: 10,
                }}
              >
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassMedium,
                    fontWeight: "400",
                    fontSize: 14,
                    color: AppColors.brown1,
                  }}
                >
                  Resign
                </Text>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              style={{
                marginTop: 20,
                flexDirection: "row",
              }}
              onPress={() => [setDotModal(false), setModalvisible3(true)]}
            >
              <View
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: 10,
                }}
              >
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassMedium,
                    fontWeight: "400",
                    fontSize: 14,
                    color: AppColors.brown1,
                  }}
                >
                  Delete
                </Text>
              </View>
            </TouchableOpacity>
          </View>
        </Modal>
        <Modal
          animationType="slide"
          transparent={true}
          visible={Modalvisible1}
          onRequestClose={() => {
            setModalvisible1(!Modalvisible1);
          }}
        >
          <Pressable
            onPress={() => setModalvisible1(true)}
            style={{
              flex: 1,
              backgroundColor: AppColors.ModalColor,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <View
              style={{
                backgroundColor: AppColors.white,
                width: "90%",
                padding: 20,
                borderRadius: 15,
                margin: 20,
              }}
            >
              <View style={{}}>
                <TouchableOpacity>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontFamily: AppFonts.OverpassRegular,
                        fontSize: 20,
                      }}
                    >
                      Block
                    </Text>
                    <TouchableOpacity onPress={() => setModalvisible1(false)}>
                      <Image
                        source={AppImages.Delpic}
                        style={{ height: 14, width: 13 }}
                      />
                    </TouchableOpacity>
                  </View>
                </TouchableOpacity>
                <View
                  style={{
                    borderWidth: 0.4,
                    borderColor: AppColors.brown1,
                    opacity: 0.099,
                    marginTop: 10,
                    marginBottom: 10,
                    alignItems: "center",
                  }}
                ></View>

                <Text
                  style={{
                    color: AppColors.brown,
                    fontFamily: AppFonts.OverpassRegular,
                    fontSize: 14,
                    width: "100%",
                  }}
                >
                  Are you sure you want to Block ?
                </Text>
                <View
                  style={{
                    borderWidth: 0.4,
                    borderColor: AppColors.brown1,
                    opacity: 0.099,
                    marginTop: 10,
                    marginBottom: 10,
                    alignItems: "center",
                  }}
                ></View>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    marginTop: 20,
                  }}
                >
                  <TouchableOpacity
                    onPress={() => setModalvisible1(false)}
                    style={{
                      width: "30%",
                      height: 44,
                      borderColor: AppColors.brown,
                      borderWidth: 1,
                      borderRadius: 15,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,
                      }}
                    >
                      Cancel
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => setModalvisible1(false)}
                    style={{
                      width: "30%",
                      height: 44,
                      backgroundColor: AppColors.brown,
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 15,
                      marginLeft: 20,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.white,
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,
                      }}
                    >
                      yes
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </Pressable>
        </Modal>
        <Modal
          animationType="slide"
          transparent={true}
          visible={Modalvisible2}
          onRequestClose={() => {
            setModalvisible2(!Modalvisible2);
          }}
        >
          <Pressable
            onPress={() => setModalvisible2(true)}
            style={{
              flex: 1,
              backgroundColor: AppColors.ModalColor,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <View
              style={{
                backgroundColor: AppColors.white,
                width: "90%",
                padding: 20,
                borderRadius: 15,
                margin: 20,
              }}
            >
              <View style={{}}>
                <TouchableOpacity>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontFamily: AppFonts.OverpassRegular,
                        fontSize: 20,
                      }}
                    >
                      Resign / Retire
                    </Text>
                    <TouchableOpacity onPress={() => setModalvisible2(false)}>
                      <Image
                        source={AppImages.Delpic}
                        style={{ height: 14, width: 13 }}
                      />
                    </TouchableOpacity>
                  </View>
                </TouchableOpacity>
                <View
                  style={{
                    borderWidth: 0.4,
                    borderColor: AppColors.brown1,
                    opacity: 0.099,
                    marginTop: 10,
                    marginBottom: 10,
                    alignItems: "center",
                  }}
                ></View>

                <Text
                  style={{
                    color: AppColors.brown,
                    fontFamily: AppFonts.OverpassRegular,
                    fontSize: 14,
                    width: "100%",
                  }}
                >
                  Are you sure you want to Resign / Retire ?
                </Text>
                <View
                  style={{
                    borderWidth: 0.4,
                    borderColor: AppColors.brown1,
                    opacity: 0.099,
                    marginTop: 10,
                    marginBottom: 10,
                    alignItems: "center",
                  }}
                ></View>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    marginTop: 20,
                  }}
                >
                  <TouchableOpacity
                    onPress={() => setModalvisible2(false)}
                    style={{
                      width: "30%",
                      height: 44,
                      borderColor: AppColors.brown,
                      borderWidth: 1,
                      borderRadius: 15,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,
                      }}
                    >
                      Cancel
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => setModalvisible2(false)}
                    style={{
                      width: "30%",
                      height: 44,
                      backgroundColor: AppColors.brown,
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 15,
                      marginLeft: 20,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.white,
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,
                      }}
                    >
                      yes
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </Pressable>
        </Modal>
        <Modal
          animationType="slide"
          transparent={true}
          visible={Modalvisible3}
          onRequestClose={() => {
            setModalvisible3(!Modalvisible3);
          }}
        >
          <Pressable
            onPress={() => setModalvisible3(true)}
            style={{
              flex: 1,
              backgroundColor: AppColors.ModalColor,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <View
              style={{
                backgroundColor: AppColors.white,
                width: "90%",
                padding: 20,
                borderRadius: 15,
                margin: 20,
              }}
            >
              <View style={{}}>
                <TouchableOpacity>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontFamily: AppFonts.OverpassRegular,
                        fontSize: 20,
                      }}
                    >
                      Delete
                    </Text>
                    <TouchableOpacity onPress={() => setModalvisible3(false)}>
                      <Image
                        source={AppImages.Delpic}
                        style={{ height: 14, width: 13 }}
                      />
                    </TouchableOpacity>
                  </View>
                </TouchableOpacity>
                <View
                  style={{
                    borderWidth: 0.4,
                    borderColor: AppColors.brown1,
                    opacity: 0.099,
                    marginTop: 10,
                    marginBottom: 10,
                    alignItems: "center",
                  }}
                ></View>

                <Text
                  style={{
                    color: AppColors.brown,
                    fontFamily: AppFonts.OverpassRegular,
                    fontSize: 14,
                    width: "100%",
                  }}
                >
                  Are you sure you want to Delete ?
                </Text>
                <View
                  style={{
                    borderWidth: 0.4,
                    borderColor: AppColors.brown1,
                    opacity: 0.099,
                    marginTop: 10,
                    marginBottom: 10,
                    alignItems: "center",
                  }}
                ></View>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    marginTop: 20,
                  }}
                >
                  <TouchableOpacity
                    onPress={() => setModalvisible3(false)}
                    style={{
                      width: "30%",
                      height: 44,
                      borderColor: AppColors.brown,
                      borderWidth: 1,
                      borderRadius: 15,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,
                      }}
                    >
                      Cancel
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => setModalvisible3(false)}
                    style={{
                      width: "30%",
                      height: 44,
                      backgroundColor: AppColors.brown,
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 15,
                      marginLeft: 20,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.white,
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,
                      }}
                    >
                      yes
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </Pressable>
        </Modal>
      </View>
    </SafeAreaView>
  );
};

export default DriverUntracked;

const styles = StyleSheet.create({
  TExtinputView: {
    flexDirection: "row",

    justifyContent: "space-between",

    alignItems: "center",

    marginTop: 15,

    width: "100%",

    // height: height * 0.04,
    marginBottom: 15,
  },

  TExtinput: {
    fontSize: 12,
    backgroundColor: AppColors.white,
    alignItems: "center",
    height: 40,
    fontFamily: AppFonts.OverpassMedium,
color:AppColors.brown2,
    width: "80%",
    paddingLeft: 8,
    borderRadius: 10,

    borderColor: AppColors.sandal,

    // height: height * 0.06,
    paddingVertical: 10,
    borderWidth: 1,

    flexDirection: "row",

    borderRadius: 8,

    justifyContent: "space-between",

    shadowColor: "#000001A",

    shadowOffset: { width: 1, height: 2 },

    shadowOpacity: 0.1,

    shadowRadius: 1, // elevation: 6,
  },

  ExImport: { flexDirection: "row", marginHorizontal: 5 },

  Flatmain: {
    marginTop: 20, // marginBottom: 20,

    backgroundColor: "#F6EFE9",

    borderRadius: 10,
  },
});
